import { TutorialAuthor } from "./TutorialAuthor";
import { Tags } from "./TutorialTags";
import { CardContainer } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

interface TutorialInfoProps {
  author: string;
  date: string;
  steps: number;
  duration: string;
  complexity: string;
  tools: Array<{
    id: number;
    documentId: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
  }>;
  tags: string[];
}

export const TutorialInfo = ({
  author,
  date,
  steps,
  duration,
  complexity,
  tools,
  tags,
}: TutorialInfoProps) => {
  const { t } = useTranslation();

  return (
    <CardContainer>
      <TutorialAuthor
        author={author}
        date={date}
        steps={steps}
        duration={duration}
        complexity={complexity}
      />

      <div className="grid grid-cols-2 md:flex md:flex-row gap-4 mt-4">
        <div className="flex-1">
          <h3 className="text-sm font-medium text-muted-foreground mb-2">{t('tutorial.info.tools')}</h3>
          <Tags tags={tools.map(tool => tool.name)} />
        </div>

        <div className="flex-1">
          <h3 className="text-sm font-medium text-muted-foreground mb-2">{t('tutorial.info.relatedTags')}</h3>
          <Tags tags={tags} />
        </div>
      </div>
    </CardContainer>
  );
};
